const ProcessesEnum = Object.freeze({
  login: 'LOGIN',
  getSurvey: 'GET_SURVEY',
  submitReview: 'SUBMIT_REVIEW',
  uploadPhotos: 'UPLOAD_PHOTOS',
  requestFollowUp: 'REQUEST_FOLLOW_UP',
});

export default ProcessesEnum;
